export type MessageReadState = {
  isPending: boolean;
  isError: boolean;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
};

/** A failed continuation waits for explicit retry, instead of starting an endless request loop. */
export function shouldContinueMessages(read: MessageReadState): boolean {
  return read.hasNextPage && !read.isFetchingNextPage && !read.isError;
}

export function replyContextReady(messages: MessageReadState, drafts: { isPending: boolean; isError: boolean }): boolean {
  return !messages.isPending && !messages.isError && !messages.hasNextPage && !drafts.isPending && !drafts.isError;
}
